import { useEffect, useRef } from 'react';

const useConditionalInterval = (callback, delay, shouldExecuteCallback = () => true) => {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            if (shouldExecuteCallback()) {
                savedCallback.current();
            }
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay, shouldExecuteCallback]);
};

export default useConditionalInterval;
